import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { tr } from "../../i18n";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      // ignore — backend ritorna sempre 204 (no enumeration)
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen bg-bg text-fg flex items-center justify-center p-6">
      <div className="bg-bg-card border border-primary/30 rounded-card shadow-hero p-8 max-w-md w-full">
        <img
          src="/icon-white-192.png"
          alt="FantaSquad"
          className="w-16 h-16 mx-auto mb-4"
          onError={(e) => {
            e.currentTarget.src = "/icon-192.png";
          }}
        />
        <h1 className="font-display text-3xl text-accent text-center mb-2 tracking-wider">
          {tr("Reset password")}
        </h1>

        {submitted ? (
          <div className="text-center space-y-4">
            <div className="text-6xl">📧</div>
            <p className="text-fg-muted text-sm">
              {tr("Se l'email")} <span className="font-mono text-fg">{email}</span>{" "}
              {tr(
                tr(
                  "è registrata, riceverai a breve un link per impostare una nuova password. Il link scade dopo 1 ora.",
                ),
              )}
            </p>
            <Link to="/login" className="btn-ghost inline-block mt-4">
              {tr("Torna al login")}
            </Link>
          </div>
        ) : (
          <>
            <p className="text-fg-muted text-center text-sm mb-6">
              {tr("Inserisci la tua email. Ti invieremo un link per impostare una nuova password.")}
            </p>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
                  {tr("Email")}
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full">
                {loading ? tr("Invio…") : tr("Invia link di reset")}
              </button>
              <p className="text-xs text-center text-fg-muted">
                <Link to="/login" className="hover:text-accent">
                  {tr("← Torna al login")}
                </Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
